if (!customElements.get('df-order-summary')) {
    customElements.define(
      'df-order-summary',
      class DfOrderSummary extends HTMLElement {
        connectedCallback() {
          this.modal = this.closest('delivery-frequency-modal');
          if (!this.modal || this.observer) return;
          this.sync = this.sync.bind(this);
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(this.modal, {
            attributes: true,
            attributeFilter: ['class', 'hidden'],
            childList: true,
            characterData: true,
            subtree: true,
          });
          this.modal.addEventListener('change', this.sync);
          this.sync();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.observer = null;
          this.modal?.removeEventListener('change', this.sync);
        }

        static cents(text) {
          const digits = (text || '').replace(/[^\d]/g, '');
          return digits ? parseInt(digits, 10) : NaN;
        }

        static money(cents) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
          return `$${(cents / 100).toFixed(2)}`;
        }

        setText(el, text) {
          if (el && el.textContent !== text) el.textContent = text;
        }

        setShown(el, shown) {
          if (el && el.hidden === shown) el.hidden = !shown;
        }

        priceOf(optionEl) {
          const wrap = optionEl?.querySelector('.df-option__price');
          if (!wrap || optionEl.classList.contains('is-unavailable') || optionEl.classList.contains('is-pricing')) return null;
          const compare = optionEl.querySelector('.df-option__price-compare');
          return {
            amount: optionEl.querySelector('.df-option__price-current')?.textContent.trim() || '',
            compare: compare && !compare.hidden ? compare.textContent.trim() : '',
          };
        }

        sync() {
          const modal = this.modal;
          const checkedOption = modal.querySelector('input[name="df_purchase_option"]:checked')?.closest('.df-option');
          const interval =
            checkedOption?.classList.contains('df-option--interval')
              ? checkedOption
              : modal.querySelector('.df-option--interval:not(.is-unavailable)');

          // Subscribe card header: price, struck-through price and saving.
          const sub = this.priceOf(interval);
          const priceEl = modal.querySelector('[data-df-mirror="price"]');
          const saveEl = modal.querySelector('[data-df-mirror="save"]');
          this.setText(modal.querySelector('[data-df-mirror="amount"]'), sub?.amount || '');
          this.setText(modal.querySelector('[data-df-mirror="compare"]'), sub?.compare || '');
          this.setShown(priceEl, Boolean(sub?.amount));

          let saving = '';
          if (sub?.amount && sub.compare) {
            const diff = DfOrderSummary.cents(sub.compare) - DfOrderSummary.cents(sub.amount);
            if (diff > 0) saving = `Save ${DfOrderSummary.money(diff)} on this order`;
          }
          this.setText(saveEl, saving);
          this.setShown(saveEl, Boolean(saving));

          // Footer subtotal for the chosen option.
          const chosen = this.priceOf(checkedOption);
          this.setText(this.querySelector('.df-summary__amount'), chosen?.amount || '');
          this.setShown(this, Boolean(chosen?.amount));
        }
      }
    );
  }
